"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStockStore = void 0;
const tslib_1 = require("tslib");
const inversify_1 = require("inversify");
const react_1 = require("react");
const ui_core_api_gateway_1 = require("@desygner/ui-core-api-gateway");
const utils_1 = require("./utils");
function useStockStore({ credentials, workspace, type: typeProps, filterOptionGroups: filterOptionGroupsProps, }) {
    const [assets, setAssets] = (0, react_1.useState)(null);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const apiGateway = (0, react_1.useMemo)(() => {
        const container = new inversify_1.Container();
        container.load(ui_core_api_gateway_1.container);
        const apiGateway = container.get(ui_core_api_gateway_1.TYPES.ApiGateway);
        apiGateway.configure(credentials.baseUrl, credentials.userToken, workspace);
        return apiGateway;
    }, [credentials.baseUrl, credentials.userToken, workspace]);
    const filterOptions = (0, react_1.useCallback)((id) => {
        var _a, _b;
        return ((_b = (_a = filterOptionGroupsProps
            .find((optionGroup) => optionGroup.id === id)) === null || _a === void 0 ? void 0 : _a.options.filter((option) => option.selected).map((option) => option.value)) !== null && _b !== void 0 ? _b : []);
    }, [filterOptionGroupsProps]);
    const fetchAssets = (0, react_1.useCallback)((value, page = 1) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        var _a;
        const type = typeProps === 'icon' ? 'Vector' : 'Image';
        const queryParams = {
            search: value,
            provider: filterOptions('provider'),
            model: filterOptions('model'),
            page: page,
        };
        const response = yield apiGateway.fetch('GET', `business/marketplace/search/${type}?${(0, utils_1.getQueryString)(queryParams)}`);
        return ((_a = response) !== null && _a !== void 0 ? _a : [])
            .map((asset) => {
            var _a, _b, _c, _d, _e;
            return ({
                data: Object.assign(Object.assign({}, asset), { is_stock: true }),
                title: (_b = (_a = asset.provider_data) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
                source: ((_d = (_c = asset.data) === null || _c === void 0 ? void 0 : _c.thumb) === null || _d === void 0 ? void 0 : _d.url) || ((_e = asset.data.web) === null || _e === void 0 ? void 0 : _e.url),
            });
        })
            .filter((asset) => asset.source);
    }), [apiGateway, filterOptions, typeProps]);
    const handleSearchEvent = (0, react_1.useCallback)((value) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setSearchTerm(value);
        const response = yield fetchAssets(value, 1);
        setAssets(response);
    }), [fetchAssets]);
    const handleLoadMoreEvent = (0, react_1.useCallback)((page = 1) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const assets = yield fetchAssets(searchTerm, page);
        return {
            items: assets,
            isLoadedAll: assets.length === 0,
        };
    }), [fetchAssets, searchTerm]);
    (0, react_1.useEffect)(() => {
        handleSearchEvent('');
    }, [handleSearchEvent]);
    return {
        assets: assets,
        actions: {
            search: handleSearchEvent,
            loadMore: handleLoadMoreEvent,
        },
    };
}
exports.useStockStore = useStockStore;
//# sourceMappingURL=useStockStore.js.map